<template>
  <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <v-row>
        <v-col cols="4">
          <validation-provider
            v-slot="{ errors }"
            name="E-mail"
            rules="required|email"
          >
            <v-text-field
              id="email"
              label="E-mail *"
              placeholder="Seu E-mail"
              :disabled="isConfirmed"
              :error-messages="errors"
              outlined
              v-model="form.email"
            ></v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="4">
          <validation-provider
            v-if="isConfirmed"
            v-slot="{ errors }"
            :name="employerType"
            rules="required|employerNumber"
          >
            <v-text-field
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              id="employerNumber"
              label="CPF/CNPJ *"
              placeholder="CPF/CNPJ"
              :error-messages="errors"
              outlined
              v-model="form.employerNumber"
            ></v-text-field>
          </validation-provider>
        </v-col>
      </v-row>

      <v-col cols="12" justify="center" align="center">
        <v-btn
          v-if="isInitialRegister"
          id="back"
          @click="back()"
          text
          large
          rounded
          color="#444444"
          class="mr-4"
          type="submit"
        >
          &lt; &lt; &nbsp; voltar
        </v-btn>
        <v-btn
          v-if="!isConfirmed"
          id="submit"
          style="color: white"
          rounded
          large
          color="#0894C0"
          class="mr-4"
          type="submit"
          :disabled="invalid"
          :loading="loading"
        >
          Confirmar
        </v-btn>
        <v-btn
          v-if="isConfirmed"
          id="next"
          style="color: white"
          rounded
          large
          color="#0894C0"
          class="mr-4"
          type="submit"
          :loading="loading"
        >
          Prosseguir
        </v-btn>
      </v-col>
    </form>
  </validation-observer>
</template>

<script>
import Jwt from "../../../api/jwt";
import _ from "lodash";
import { mapGetters } from "vuex";
import { email, required } from "vee-validate/dist/rules";
import EmployerNumberValidator from "../../../helpers/validators/employerNumber.validator";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { mask } from "vue-the-mask";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "Favor informar {_field_}."
});
extend("employerNumber", {
  ...EmployerNumberValidator,
  message: "{_field_} inválido."
});
extend("email", {
  ...email,
  message: "E-mail inválido."
});

export default {
  name: "RegisterForm",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  directives: { mask },
  data: () => ({
    loading: false,
    form: {
      email: "",
      employerNumber: ""
    },
    employerType: "cpf",
    isConfirmed: false
  }),
  props: {
    isInitialRegister: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      me: "$_auth/me",
      rmProvider: "$_rmProvider/provider",
      providers: "$_provider/providers"
    })
  },
  methods: {
    async submit() {
      this.loading = true;
      if (!this.isConfirmed) {
        const result = await this.$store.dispatch(
          `$_auth/preRegister`,
          this.form
        );
        if (_.hasIn(result, "status") && result.status == 201) {
          await this.$store.dispatch(`$_messages/setErrors`, {
            message:
              "Um email de verificação foi enviado a sua caixa de entrada.",
            type: "success",
            title: "Sucesso!",
            timeout: 8000
          });
          this.snackbar = true;
          this.$router.push({ name: "auth.login" });
        }
      } else {
        let employerNumber = this.form.employerNumber.replace(/[^0-9]/g, "");
        await this.$store.dispatch(`$_provider/index`, {
          employer_number: employerNumber
        });
        if (this.providers.length > 0) {
          let message = "";
          if (this.providers[0].status_register === "pending") {
            message = `Este ${this.employerType.toUpperCase()} já está em processo de cadastramento!.`;
          } else if (this.providers[0].status_register === "approved") {
            message = `Este ${this.employerType.toUpperCase()} já possui um cadastro validado no sistema!.`;
          } else {
            message = `A solicitação de cadastro para esse ${this.employerType.toUpperCase()} foi reprovada. Favor entrar em contato com o Sebrae/BA para maiores informações.`;
          }

          await this.$store.dispatch(`$_messages/setErrors`, {
            message: message,
            type: "error",
            title: "Error!",
            timeout: 8000
          });
        } else {
          try {
            await this.$store.dispatch(`$_rmProvider/show`, employerNumber);
            this.$router.replace({
              name: "register",
              query: { passo: 3, employer_number: this.form.employerNumber }
            });
          } catch (error) {
            await this.$store.dispatch(`$_messages/setErrors`, {
              message:
                "Erro interno. Favor entrar em contato com o suporte. Informar o codigo 408.",
              type: "error",
              title: "Error!",
              timeout: 8000
            });
          }
        }
      }
      this.loading = false;
    },
    async back() {
      await this.$store.dispatch(`$_auth/logout`);
      this.$store.commit("$_auth/DELETE_ME_AUTHENTICATED");
      this.$router.push("/autenticacao");
    }
  },
  async created() {
    if (this.$route.query.token) {
      Jwt.saveToken(this.$route.query.token);
      try {
        await this.$store.dispatch(`$_auth/me`);
        this.isConfirmed = true;
        this.form.email = this.me.email;
      } catch (error) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message:
            "Este link já foi utilizado anteriormente e o CPF/CNPJ já está em processo de cadastramento.",
          type: "error",
          title: "Sucesso!",
          timeout: 8000
        });
        this.$router.push({ name: "auth.login" });
      }
    }
  },
  watch: {
    "form.employerNumber"(newValue) {
      if (newValue.length > 14) {
        this.employerType = "Cnpj";
      } else {
        this.employerType = "Cpf";
      }
    }
  }
};
</script>
